import React from 'react'
import styled from 'styled-components'

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.card_background};
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 1200px;
    margin: 10px 0px;
    transition: transform 0.3s ease;
    transform: scale(0.89);
    transition: transform 2s;
    transform-origin: top center;
    border: 0.1px solid #854CE6;
    z-index:200;
    margin-bottom:30px;
    &:hover {
        transform: scale(1.03);
    }
`;

const Role = styled.h3`
    font-size: 22px;
    color: ${({ theme }) => theme.primary};
    font-weight: 600;
    margin-bottom: 10px;
`;

const Company = styled.div`
    font-size: 18px;
    color: ${({ theme }) => theme.text_secondary};
    margin-bottom: 10px;
    font-weight: 700;
`;

const Date = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 10px;
    text-align:center;
 border: 0.1px solid #854CE6;
 border-radius:5px;
 padding:2px;
 width:55%;

`;

const Desc = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.text_secondary};
    margin-bottom: 12px;
`;

const Tags = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
`;

const Tag = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.primary + 15};
    padding: 2px 8px;
    border-radius: 10px;
`

const ExperienceCard = ({ experience }) => {
    return (
        <CardContainer>
            <Role>{experience.role}</Role>
            <Company>{experience.company}</Company>
            <Date>{experience.date}</Date>
            <Desc>{experience.desc}</Desc>

            <Tags>
                {experience.skills?.map((skills, index) => (
                    <Tag>{skills}</Tag>
                ))}
            </Tags>
        </CardContainer>
    );
};

export default ExperienceCard;
